// NOTE this file contains the internal dependencies of @lvflanders BAR modules
// we use this to avoid having to break whenever a new version is used
// UMD bundles from ngx-packagr through Angular Libraries doesn't bundle this code (because not possible or too difficult)
import * as ngxExtendedPdfViewer from 'ngx-extended-pdf-viewer';

// global glue variable for externals
window['ngx-extended-pdf-viewer'] = ngxExtendedPdfViewer;

export { ngxExtendedPdfViewer };
